var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
// '#context' is imported by direct path: its barrel would close the context <-> query-hooks cycle (see CLAUDE.md).
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { RefetchIntervals } from '#constants';
import { useAuthProvider } from '#context/AuthProvider';
import { getAmplitudeAppVersion, getAmplitudeExperimentClient, } from '#integrations';
export const useFeatureFlags = () => {
    _react_refresh_temp_1();
    const experimentClient = getAmplitudeExperimentClient();
    const { currentUser } = useAuthProvider();
    const query = useQuery({
        queryKey: ['featureFlags'],
        queryFn: async () => {
            // fetch is required to get up to date flags
            // experimentClient.fetch requires passing user_id param to properly link ids for remote evaluation
            // version is passed explicitly as the analytics SDK doesn't forward appVersion to Experiment
            const appVersion = getAmplitudeAppVersion();
            await experimentClient.fetch({
                ...(currentUser && { user_id: currentUser.id }),
                ...(appVersion && { version: appVersion }),
            });
            return experimentClient.all();
        },
        networkMode: 'always',
        retry: false,
        refetchInterval: RefetchIntervals.xxl,
        // Keeping 'enabled' commented out for now, as for environments that do not have an experiment client
        // (such as local) we still want to be able to have an error / pending / success state
        // In the future if we have a local mocked version of the experiment client we can return the 'enabled'
        // property
        // enabled: Boolean(experimentClient),
    });
    // If this is not extracted from the 'query' object, the 'useEffect' bellow will non-stop try to refetch
    // as the reference of the 'query' object is not stable
    // ref: https://tanstack.com/query/v5/docs/framework/react/guides/render-optimizations#referential-identity
    const { refetch } = query;
    useEffect(() => {
        // Refetching on currentUser.id change since experimentClient.fetch
        // requires passing user_id param to properly link ids for remote evaluation
        void refetch();
    }, [currentUser?.id, refetch]);
    return { query };
};
_react_refresh_temp_1(useFeatureFlags, "tTtgrgX+XkUv6K81fJnDsVqLr0Y=", false, () => [useAuthProvider, useQuery]);
